import {
  getBaselineMinLookbackSeconds,
  getBaselineMinLookbackValues,
  getBaselineOverallSetting
} from 'app/stores/alerting/policyUtils';

function deserialize(policy) {
  const {
    baselineSettings: oldBaselineSettings = {
      startOffset: '',
      length: ''
    },
    ...restPolicy
  } = policy;

  const baselineSettings = {
    ...oldBaselineSettings,
    startOffset: Number(oldBaselineSettings.startOffset.replace('s', '')),
    length: Number(oldBaselineSettings.length.replace('s', '')),
    ...getBaselineMinLookbackValues(oldBaselineSettings.minimalLength),
    datapointAggregationMethod:
      oldBaselineSettings.datapointAggregationMethod !== 'None' ? oldBaselineSettings.datapointAggregationMethod : '',
    comparisonValueAggregateFunction:
      oldBaselineSettings.comparisonValueAggregateFunction !== 'None'
        ? oldBaselineSettings.comparisonValueAggregateFunction
        : '',
    neighbourhoodAggregationMethod:
      oldBaselineSettings.neighbourhoodAggregationMethod !== 'None'
        ? oldBaselineSettings.neighbourhoodAggregationMethod
        : '',
    neighbourhoodRadius: oldBaselineSettings.neighbourhoodRadius || 1
  };

  const baselinePresetType = getBaselineOverallSetting({
    nTopKeysAddedToBaseline: restPolicy.nTopKeysAddedToBaseline,
    nTopKeysEvaluated: restPolicy.nTopKeysEvaluated,
    baselineSettings
  });

  return {
    ...restPolicy,
    baselineSettings,
    uiProperties: {
      ...(restPolicy.uiProperties || {}),
      baselinePresetType // new
    }
  };
}

function serialize(policy) {
  const { baselineSettings, ...restPolicy } = policy;

  if (!policy.baselineSettings) {
    return restPolicy;
  }

  // drop the UI-only field
  const { minimal_length_unit, ...restBaselineSettings } = baselineSettings;

  return {
    ...restPolicy,
    baselineSettings: {
      ...restBaselineSettings,
      startOffset: `${baselineSettings.startOffset}s`,
      length: `${baselineSettings.length}s`,
      // this comes to us in seconds initially from the api
      minimalLength: `${getBaselineMinLookbackSeconds(
        baselineSettings.minimalLength,
        baselineSettings.minimal_length_unit
      )}s`,
      datapointAggregationMethod: baselineSettings.datapointAggregationMethod || 'None',
      neighbourhoodAggregationMethod: baselineSettings.neighbourhoodAggregationMethod || 'None',
      neighbourhoodRadius: baselineSettings.neighbourhoodAggregationMethod ? baselineSettings.neighbourhoodRadius : 0,
      comparisonValueAggregateFunction: baselineSettings.comparisonValueAggregateFunction || 'None'
    }
  };
}

export default {
  serialize,
  deserialize
};
